import { Row, Col, Button, Alert, Checkbox } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { FormSwitcher, FormTitle, Label, TextField } from 'components';
import React, { useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { initiateLoginFlow, getOAuth2Clients, initiateGsisLogin } from 'store/user/actions';
import { types } from 'store/user/types';
import { types as formTypes } from 'store/form/types';
import { readUrlParams, resolveMessageCode, oauth2ProviderInterceptorUrl } from 'utils';
import keycloak from 'Keycloak.js';

const LoginPage = () => {
  const dispatch = useDispatch();
  const params =  useSelector(state => state.user);
  const initiated =  useSelector(state => state.form.initiated);
  const hasError =  useSelector(state => state.form.hasError);
  const hasInfo =  useSelector(state => state.form.hasInfo);
  const loading =  useSelector(state => state.form.loading);
  const message =  useSelector(state => state.form.message);
  const gsisAuthUrl =  useSelector(state => state.form.gsisAuthUrl);
  const inputRef = useRef(null);
  const onRememberMeChange = (e) => {
    const payload = {};
    payload.rememberMe = e.target.checked;
    dispatch({ type: types.UPDATE_USER.SUCCESS, payload: payload });
  };
  const submitClicked = (e) => {
    dispatch(initiateLoginFlow(params));
  };
  const authProviderSubmitClicked = (e) => {
    if (process.env.REACT_APP_INTERCEPT_OAUTH2_PROVIDER == 1) {
      const interceptor = window.open(oauth2ProviderInterceptorUrl,'_blank', 'toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,left=10000, top=10000, width=10, height=10, visible=none', ''); 
    }
    dispatch(initiateGsisLogin(gsisAuthUrl));
  };
  useEffect(() => {
  dispatch({ type: types.RESET_USER });
  dispatch({ type: formTypes.RESET_FORM });
  const urlParams = readUrlParams();
  if (urlParams.origin) {
  dispatch({ type: formTypes.SET_FORM_INFO, payload: resolveMessageCode(urlParams.origin) });
  }
    keycloak.tracker.invalidateUserForAuthPages(true, () => {
  dispatch(getOAuth2Clients());
  dispatch({ type: formTypes.SET_FORM_INITIATED });
  }); 
  }, []);
  useEffect(() => {
    initiated && inputRef.current.focus();
  }, [initiated]);
  return (
    initiated &&
    <div className="login-page" style={{marginTop:"0px"}}>
      <Row className="page-title-row login-title-row">
        <Col span={24} className="page-title-col login-title-col">
          <Label
            label="Είσοδος στην Εφαρμογή"
            labelClassName="page-title-label login-title-label"
          />
          <p>Για την υποβολή και την παρακολουθήση της πορείας της αίτησή σας στο Μητρώο Εγκαταστατών  εισέλθετε στην εφαρμογή χρησιμοποιώντας τους προσωπικούς κωδικούς που έχετε στο Taxisnet.</p>
          <p>Συνεχίζοντας επιβεβαιώνετε ότι έχετε διαβάσει και συμφωνείτε με την πολιτική απορρήτου, τον Οδηγό Εφαρμογής του Προγράμματος και την πολιτική cookies.</p>
        </Col>
      </Row>
      <Row className="error-wrapper-row">
        <Col span={24} className="error-wrapper-col">
          {hasError && <Alert
            message="Σφάλμα"
            description={message}
            className="error-component"
            type="error"
            icon={<ExclamationCircleFilled />}
            closable
            showIcon
          />}
          {hasInfo && <Alert
            //message="Σφάλμα"
            description={message}
            className="info-component"
            type="info"
            icon={<ExclamationCircleFilled />}
            closable
            showIcon
          />}
        </Col>
      </Row>
      {gsisAuthUrl && <Row className="oauth2-provider-row">
        <Col span={11} className="oauth2-provider-col">
          <Button
            type="primary"
            className="oauth2-provider-submit"
            disabled={loading}
            onClick={authProviderSubmitClicked}
            >Είσοδος με διαπιστευτήρια TAXISnet</Button>
        </Col>
      </Row>}
      <FormSwitcher id="form-control" />
      <Row className="form-title-row">
        <Col span={11} className="form-title-col">
          <FormTitle
            label="Είσοδος ως διαχειριστής"
            labelClassName="form-title"
            forComponent="form-control"
          />
        </Col>
      </Row>
      <div class="form-login-wrapper">
        <Row className="userpass-wrapper-row">
          <Col span={11} className="userpass-wrapper-col">
            <TextField
              className="username-component"
              labelClassName="userpass-label username-label"
              containerClassName="username-container"
              fieldName="username"
              fieldType="text"
              label="Email Χρήστη"
              size="large"
              placeholder="Εισάγετε email"
              disabled={loading}
              customRef={inputRef}
              onPressEnter={submitClicked}
            />
            <TextField
              className="password-component"
              labelClassName="userpass-label password-label"
              containerClassName="password-container"
              fieldName="password"
              fieldType="password"
              label="Κωδικός Πρόσβασης"
              size="large"
              placeholder="Εισάγετε κωδικό"
              disabled={loading}
              onPressEnter={submitClicked}
            />
          </Col>
        </Row>
        <Row className="forgotpass-wrapper-row">
          <Col span={11} className="forgotpass-wrapper-col">
            <Link
              to="/forgot-password"
              className="forgotpass-component"
              >Ξέχασα τον κωδικό μου</Link>
          </Col>
        </Row>
        <Row className="remember-wrapper-row">
          <Col span={11} className="remember-wrapper-col">
            <Checkbox
              className="remember-component"
              checked={params.rememberMe}
              onChange={onRememberMeChange}
              labelClassName="remember-label"
              >Να με θυμάσαι</Checkbox>
          </Col>
        </Row>
        <Row className="buttons-wrapper-row">
          <Col span={11} className="buttons-wrapper-col">
            <Button
              type="primary"
              className="submit-component"
              disabled={loading}
              onClick={submitClicked}
              >Είσοδος</Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default LoginPage;
